import { Collapse, CollapseItem, Upload, DatePicker, TimeSelect, Table, TableColumn, Tag, Input, Button, Select, Option, Popover } from 'element-ui';
import { Switch as LSwitch } from '@/components/index';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();
import MedalDecider from '@/components/shared/medals/club/decider/decider.vue'

export default {
    name: 'dashboardManageClubs',
    props: ['userId'],
    components: {
        'medal-decider': MedalDecider,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Table.name]: Table, [TableColumn.name]: TableColumn, [DatePicker.name]: DatePicker, [TimeSelect.name]: TimeSelect, [Tag.name]: Tag, [Input.name]: Input, [Select.name]: Select, [Option.name]: Option, [Upload.name]: Upload, [Button.name]: Button, [Popover.name]: Popover, LSwitch,
    },
    data() {
        return {
            loadedUserId: 0,
            isProcessing: false,
            errorMessage: null,
            tableData: [],
            years: [],
            selectedYear: 0,
            user: null,
            goldNumber: 1
        };
    },
    computed: {
        clubsBySelectedYear() {
            var self = this;
            if (!self.tableData) {
                return []
            }
            var data = self.tableData.filter(x => {
                return x.year == self.selectedYear;
            });

            if (data && data.length) {
                return data[0].clubs;
            }
            return [];
        },
        domain() {
            return process.env.url.oldApp;
        }
    },
    methods: {
        removeFlow(status) {
            return status == 3 || status == 4;
        },
        getData() {
            var self = this;
            self.isProcessing = true;
            svc.getClubsManagedByRemovalOfficers().then(response => {
                var allData = response.body;
                self.isProcessing = false;
                if (!allData) {
                    self.errorMessage = "Something went wrong!";
                    return;
                }
                if (!allData.isSuccess) {
                    self.errorMessage = allData.message;
                    return;
                }
                else {
                    self.errorMessage = null;
                    self.tableData = allData.clubsByYears;
                    self.years = allData.years;
                    if (self.years && self.years.length) {
                        self.selectedYear = self.years[0];
                    }
                }

                self.$console();
                self.$console({ clubs: self.tableData });

                self.tableData;
            }, () => {
                self.isProcessing = false;
                self.errorMessage = "Something went wrong, please contact with dev team!";
            });
        },
        payForClub(id) {
            var self = this;
            self.isProcessing = true;
            svc.prepareClubAffilation(id).then(response => {
                if (response.body) {
                    if (response.body.isSuccess && response.body.redirectUrl) {
                        self.$router.push({ path: response.body.redirectUrl });
                    }
                    else if (response.body.message) {
                        self.$notify({ type: 'danger', message: response.body.message });
                    }
                    else {
                        self.$notify({ type: 'danger', message: 'Please, refresh page and try again' });
                    }
                    self.isProcessing = false;
                }
                else {
                    self.$notify({ type: 'danger', message: 'Something went wrong. Creating payment is not possible.' })
                }
            }, () => {
                self.$notify({ type: 'danger', message: 'Something went wrong. Creating payment is not possible.' });
                self.isProcessing = false;
            })
        }
    },
    created() {
        var self = this;
        self.getData();
        EventBus.$emit("user-load-dashboard-card", 0);
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/manage-clubs-by-officers/manage-clubs.js